import React from 'react'
import { 
    Button
  } from '@material-ui/core';
const CareersUpdateButton = props => {
  return <Button color="primary" variant="contained" onClick={props.addClick}>Update</Button>
}

export default CareersUpdateButton